// This file is generated by Sapper — do not edit it!
// webpack does not support export * as root_comp yet so do a two line import/export
import * as root_comp from '../../../routes/_layout.svelte';
export { root_comp };
export { default as ErrorComponent } from '../../../routes/_error.svelte';

export const ignore = [/^\/sitemap\.xml$/, /^\/sublimation\/?$/, /^\/mail\/unsubscribe\/([^/]+?)\.json$/];

export const components = [
	{
		js: () => import("../../../routes/index.svelte")
	},
	{
		js: () => import("../../../routes/terms-conditions.svelte")
	},
	{
		js: () => import("../../../routes/products-filter/index.svelte")
	},
	{
		js: () => import("../../../routes/privacy-policy.svelte")
	},
	{
		js: () => import("../../../routes/returns-policy.svelte")
	},
	{
		js: () => import("../../../routes/checkout/_layout.svelte")
	},
	{
		js: () => import("../../../routes/checkout/index.svelte")
	},
	{
		js: () => import("../../../routes/checkout/contact-details.svelte")
	},
	{
		js: () => import("../../../routes/checkout/payment-details.svelte")
	},
	{
		js: () => import("../../../routes/checkout/complete.svelte")
	},
	{
		js: () => import("../../../routes/products/index.svelte")
	},
	{
		js: () => import("../../../routes/products/[category]/index.svelte")
	},
	{
		js: () => import("../../../routes/products/[category]/[collection]/_layout.svelte")
	},
	{
		js: () => import("../../../routes/products/[category]/[collection]/index.svelte")
	},
	{
		js: () => import("../../../routes/account/_layout.svelte")
	},
	{
		js: () => import("../../../routes/account/index.svelte")
	},
	{
		js: () => import("../../../routes/account/newsletter.svelte")
	},
	{
		js: () => import("../../../routes/account/delivery.svelte")
	},
	{
		js: () => import("../../../routes/account/password.svelte")
	},
	{
		js: () => import("../../../routes/account/referral.svelte")
	},
	{
		js: () => import("../../../routes/account/profile.svelte")
	},
	{
		js: () => import("../../../routes/account/rewards.svelte")
	},
	{
		js: () => import("../../../routes/account/orders.svelte")
	},
	{
		js: () => import("../../../routes/account/logos.svelte")
	},
	{
		js: () => import("../../../routes/contact.svelte")
	},
	{
		js: () => import("../../../routes/product/[slug].svelte")
	},
	{
		js: () => import("../../../routes/sitemap.svelte")
	},
	{
		js: () => import("../../../routes/design/index.svelte")
	},
	{
		js: () => import("../../../routes/design/load/[savedDesignId].svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/_layout.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/index.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/choose-uniform-items.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/choose-template.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/choose-colours.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/review-order.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/team-details.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/front-print.svelte")
	},
	{
		js: () => import("../../../routes/design/[productSlug]/back-print.svelte")
	},
	{
		js: () => import("../../../routes/orders/edit/[cartItemIdentifier].svelte")
	},
	{
		js: () => import("../../../routes/orders/[orderId].svelte")
	},
	{
		js: () => import("../../../routes/about.svelte")
	},
	{
		js: () => import("../../../routes/login.svelte")
	},
	{
		js: () => import("../../../routes/reset.svelte")
	},
	{
		js: () => import("../../../routes/blog/index.svelte")
	},
	{
		js: () => import("../../../routes/blog/[slug].svelte")
	},
	{
		js: () => import("../../../routes/cart.svelte")
	},
	{
		js: () => import("../../../routes/faqs.svelte")
	},
	{
		js: () => import("../../../routes/mail/unsubscribe/[token].svelte")
	},
	{
		js: () => import("../../../routes/[category]/index.svelte")
	},
	{
		js: () => import("../../../routes/[category]/[collection]/index.svelte")
	}
];

export const routes = (d => [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// terms-conditions.svelte
		pattern: /^\/terms-conditions\/?$/,
		parts: [
			{ i: 1 }
		]
	},

	{
		// products-filter/index.svelte
		pattern: /^\/products-filter\/?$/,
		parts: [
			{ i: 2 }
		]
	},

	{
		// privacy-policy.svelte
		pattern: /^\/privacy-policy\/?$/,
		parts: [
			{ i: 3 }
		]
	},

	{
		// returns-policy.svelte
		pattern: /^\/returns-policy\/?$/,
		parts: [
			{ i: 4 }
		]
	},

	{
		// checkout/index.svelte
		pattern: /^\/checkout\/?$/,
		parts: [
			{ i: 5 },
			{ i: 6 }
		]
	},

	{
		// checkout/contact-details.svelte
		pattern: /^\/checkout\/contact-details\/?$/,
		parts: [
			{ i: 5 },
			{ i: 7 }
		]
	},

	{
		// checkout/payment-details.svelte
		pattern: /^\/checkout\/payment-details\/?$/,
		parts: [
			{ i: 5 },
			{ i: 8 }
		]
	},

	{
		// checkout/complete.svelte
		pattern: /^\/checkout\/complete\/?$/,
		parts: [
			{ i: 5 },
			{ i: 9 }
		]
	},

	{
		// products/index.svelte
		pattern: /^\/products\/?$/,
		parts: [
			{ i: 10 }
		]
	},

	{
		// products/[category]/index.svelte
		pattern: /^\/products\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 11, params: match => ({ category: d(match[1]) }) }
		]
	},

	{
		// products/[category]/[collection]/index.svelte
		pattern: /^\/products\/([^/]+?)\/([^/]+?)\/?$/,
		parts: [
			null,
			null,
			{ i: 12, params: match => ({ category: d(match[1]), collection: d(match[2]) }) },
			{ i: 13, params: match => ({ category: d(match[1]), collection: d(match[2]) }) }
		]
	},

	{
		// account/index.svelte
		pattern: /^\/account\/?$/,
		parts: [
			{ i: 14 },
			{ i: 15 }
		]
	},

	{
		// account/newsletter.svelte
		pattern: /^\/account\/newsletter\/?$/,
		parts: [
			{ i: 14 },
			{ i: 16 }
		]
	},

	{
		// account/delivery.svelte
		pattern: /^\/account\/delivery\/?$/,
		parts: [
			{ i: 14 },
			{ i: 17 }
		]
	},

	{
		// account/password.svelte
		pattern: /^\/account\/password\/?$/,
		parts: [
			{ i: 14 },
			{ i: 18 }
		]
	},

	{
		// account/referral.svelte
		pattern: /^\/account\/referral\/?$/,
		parts: [
			{ i: 14 },
			{ i: 19 }
		]
	},

	{
		// account/profile.svelte
		pattern: /^\/account\/profile\/?$/,
		parts: [
			{ i: 14 },
			{ i: 20 }
		]
	},

	{
		// account/rewards.svelte
		pattern: /^\/account\/rewards\/?$/,
		parts: [
			{ i: 14 },
			{ i: 21 }
		]
	},

	{
		// account/orders.svelte
		pattern: /^\/account\/orders\/?$/,
		parts: [
			{ i: 14 },
			{ i: 22 }
		]
	},

	{
		// account/logos.svelte
		pattern: /^\/account\/logos\/?$/,
		parts: [
			{ i: 14 },
			{ i: 23 }
		]
	},

	{
		// contact.svelte
		pattern: /^\/contact\/?$/,
		parts: [
			{ i: 24 }
		]
	},

	{
		// product/[slug].svelte
		pattern: /^\/product\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 25, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// sitemap.svelte
		pattern: /^\/sitemap\/?$/,
		parts: [
			{ i: 26 }
		]
	},

	{
		// design/index.svelte
		pattern: /^\/design\/?$/,
		parts: [
			{ i: 27 }
		]
	},

	{
		// design/load/[savedDesignId].svelte
		pattern: /^\/design\/load\/([^/]+?)\/?$/,
		parts: [
			null,
			null,
			{ i: 28, params: match => ({ savedDesignId: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/index.svelte
		pattern: /^\/design\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 30, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/choose-uniform-items.svelte
		pattern: /^\/design\/([^/]+?)\/choose-uniform-items\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 31, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/choose-template.svelte
		pattern: /^\/design\/([^/]+?)\/choose-template\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 32, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/choose-colours.svelte
		pattern: /^\/design\/([^/]+?)\/choose-colours\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 33, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/review-order.svelte
		pattern: /^\/design\/([^/]+?)\/review-order\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 34, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/team-details.svelte
		pattern: /^\/design\/([^/]+?)\/team-details\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 35, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/front-print.svelte
		pattern: /^\/design\/([^/]+?)\/front-print\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 36, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// design/[productSlug]/back-print.svelte
		pattern: /^\/design\/([^/]+?)\/back-print\/?$/,
		parts: [
			null,
			{ i: 29, params: match => ({ productSlug: d(match[1]) }) },
			{ i: 37, params: match => ({ productSlug: d(match[1]) }) }
		]
	},

	{
		// orders/edit/[cartItemIdentifier].svelte
		pattern: /^\/orders\/edit\/([^/]+?)\/?$/,
		parts: [
			null,
			null,
			{ i: 38, params: match => ({ cartItemIdentifier: d(match[1]) }) }
		]
	},

	{
		// orders/[orderId].svelte
		pattern: /^\/orders\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 39, params: match => ({ orderId: d(match[1]) }) }
		]
	},

	{
		// about.svelte
		pattern: /^\/about\/?$/,
		parts: [
			{ i: 40 }
		]
	},

	{
		// login.svelte
		pattern: /^\/login\/?$/,
		parts: [
			{ i: 41 }
		]
	},

	{
		// reset.svelte
		pattern: /^\/reset\/?$/,
		parts: [
			{ i: 42 }
		]
	},

	{
		// blog/index.svelte
		pattern: /^\/blog\/?$/,
		parts: [
			{ i: 43 }
		]
	},

	{
		// blog/[slug].svelte
		pattern: /^\/blog\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 44, params: match => ({ slug: d(match[1]) }) }
		]
	},

	{
		// cart.svelte
		pattern: /^\/cart\/?$/,
		parts: [
			{ i: 45 }
		]
	},

	{
		// faqs.svelte
		pattern: /^\/faqs\/?$/,
		parts: [
			{ i: 46 }
		]
	},

	{
		// mail/unsubscribe/[token].svelte
		pattern: /^\/mail\/unsubscribe\/([^/]+?)\/?$/,
		parts: [
			null,
			null,
			{ i: 47, params: match => ({ token: d(match[1]) }) }
		]
	},

	{
		// [category]/index.svelte
		pattern: /^\/([^/]+?)\/?$/,
		parts: [
			{ i: 48, params: match => ({ category: d(match[1]) }) }
		]
	},

	{
		// [category]/[collection]/index.svelte
		pattern: /^\/([^/]+?)\/([^/]+?)\/?$/,
		parts: [
			null,
			{ i: 49, params: match => ({ category: d(match[1]), collection: d(match[2]) }) }
		]
	}
])(decodeURIComponent);